// extracted by mini-css-extract-plugin
export default {"burgerNavigationsWrapper":"_BurgerNavigations_burgerNavigationsWrapper__HRksY","navigations_item":"_BurgerNavigations_navigations_item__6ZPxh"};